import { render, staticRenderFns } from "./AppGrandesCuentas.vue?vue&type=template&id=24876433&scoped=true&"
import script from "./AppGrandesCuentas.vue?vue&type=script&lang=js&"
export * from "./AppGrandesCuentas.vue?vue&type=script&lang=js&"
import style0 from "./AppGrandesCuentas.vue?vue&type=style&index=0&id=24876433&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24876433",
  null
  
)

export default component.exports